export enum Gender {
    MALE = "male",
    FEMALE = "female",
    NON_BINARY = "non-binary",
}